import { useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

// Custom decoding for Safari compatibility
const dereplaceSpecialChars = (str) => {
    if (!str) return str;
    return str
        .replace(/__e__/g, 'ê')
        .replace(/__c__/g, 'ç')
        .replace(/__a1__/g, 'á')
        .replace(/__a2__/g, 'à')
        .replace(/__a3__/g, 'â')
        .replace(/__a4__/g, 'ã')
        .replace(/__e1__/g, 'é')
        .replace(/__e2__/g, 'è')
        .replace(/__o1__/g, 'ó')
        .replace(/__o2__/g, 'ò')
        .replace(/__o3__/g, 'õ')
        .replace(/__o4__/g, 'ô')
        .replace(/__i1__/g, 'í')
        .replace(/__u1__/g, 'ú')
        .replace(/__u2__/g, 'ü');
};

export default function LicitacaoDetalhada() {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const [licitacoes, setLicitacoes] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);
    const [apiUrl, setApiUrl] = useState('');
    const location = useLocation();
    const totalAdjudicado = searchParams.get('total');
    console.log("Total Adjudicado vindo do state:", totalAdjudicado);

    useEffect(() => {
        setLoading(true);
        setError(false);

        if (id) {
            // modo antigo: carrega por ID
            const url = `https://www.alepe.pe.gov.br/licitacoes/list.php?ID=${id}`;
            setApiUrl(url);
            fetch(url)
                .then(res => res.json())
                .then(json => {
                    if (json?.data?.length > 0) {
                        setLicitacoes([json.data[0]]);
                    } else {
                        setLicitacoes([]);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    console.error('Erro na requisição por ID:', err);
                    setError(true);
                    setLoading(false);
                });
        } else {
            // Decode custom-encoded parameters
            const numeroprocesso = dereplaceSpecialChars(searchParams.get('numeroprocesso'));
            const ano = dereplaceSpecialChars(searchParams.get('ano'));
            const modalidade = dereplaceSpecialChars(searchParams.get('modalidade'));
            const status = dereplaceSpecialChars(searchParams.get('status'));

            const query = new URLSearchParams();
            if (numeroprocesso) query.append('numeroprocesso', numeroprocesso);
            if (ano) query.append('ano', ano);
            if (modalidade) query.append('modalidade', modalidade);
            if (status) query.append('status', status);

            // Replace + with %20 for Safari compatibility
            const url = `https://www.alepe.pe.gov.br/licitacoes/list.php?${query.toString().replace(/\+/g, '%20')}`;
            setApiUrl(url);
            fetch(url)
                .then(res => res.json())
                .then(json => {
                    setLicitacoes(json?.data || []);
                    setLoading(false);
                })
                .catch((err) => {
                    console.error('Erro na requisição por filtros:', err);
                    setError(true);
                    setLoading(false);
                });
        }
    }, [id, searchParams]);

    if (loading) return <div>Carregando...</div>;
    if (error) return <div>Erro ao carregar os dados.</div>;
    if (!licitacoes.length) {
        return (
            <div>
                <p>Licitação não encontrada.</p>
                <p style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
                    <strong>Parâmetros da requisição:</strong>
                </p>
                <pre style={{
                    backgroundColor: '#f5f5f5',
                    padding: '10px',
                    borderRadius: '4px',
                    overflow: 'auto',
                    fontSize: '12px'
                }}>
                    {apiUrl}
                </pre>
            </div>
        );
    }

    const licitacao = licitacoes[0]; // usa o primeiro para o título

    return (
        <div>
            <p><small>Você está em <a href="/financas">Prestação de Contas</a> / <a href="/financas/licitacoes">Licitações</a> / {`${licitacao.NOMEMODALIDADE} ${licitacao.NUMEROMODALIDADE}/${licitacao.ANOMODALIDADE}`}</small></p>
            <Row>
                <Col xs="12" className="text-center">
                    <h2>{`${licitacao.NOMEMODALIDADE} ${licitacao.NUMEROMODALIDADE}/${licitacao.ANOMODALIDADE}`}</h2>
                    <h2 style={{ fontSize: '80%' }}>{`Processo ${licitacao.NUMEROPROCESSO}/${licitacao.ANOPROCESSO}`}</h2>
                </Col>

                <Col xs="12" className='mt-3'>
                    <div className="proposicao-list-item-header"><h3>Objeto conforme Edital</h3></div>
                    <div className="proposicao-list-item-text"><p style={{ textAlign: 'justify' }}>{licitacao.OBJETOCONFORMEEDITAL}</p></div>
                </Col>

                <Col xs="12" className='mt-3'>
                    <div className="proposicao-list-item-header"><h3>Total Adjudicado</h3></div>
                    <div className="proposicao-list-item-text">
                        <p style={{ textAlign: 'justify' }}>
                            {totalAdjudicado !== undefined && totalAdjudicado !== null && !isNaN(Number(totalAdjudicado))
                                ? Number(totalAdjudicado).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                                : 'Nenhum valor adjudicado'}
                        </p>
                    </div>
                </Col>


              

                {licitacoes.some(item => item.RAZAOSOCIAL && item.RAZAOSOCIAL !== '-') && (
                    <Col xs="12" className='mt-3'>
                        <h3>Vencedores</h3>
                    </Col>
                )}
                {licitacoes.map((item, idx) => (
                    <Col key={idx} xs="12" className='mt-3 mb-5 table-responsive'>
                        <Table>
                            <tbody>
                                <tr><td><strong>STATUS:</strong></td><td>{item.SITUACAOLICITACAO || '-'}</td></tr>
                                <tr><td><strong>Data de Abertura:</strong></td><td>{item.DATASESSAOABERTURA ? new Date(item.DATASESSAOABERTURA.date).toLocaleDateString() : '-'}</td></tr>
                                <tr><td><strong>Vencedor:</strong></td><td>{item.RAZAOSOCIAL || '-'}</td></tr>
                                <tr><td><strong>CPF/CNPJ:</strong></td><td>{item.NUMERODOCUMENTOAJUSTADO || '-'}</td></tr>
                                <tr>
                                    <td><strong>Valor Adjudicado:</strong></td>
                                    <td>{item.TOTALADJUDICADOLICITANTE !== undefined && item.TOTALADJUDICADOLICITANTE !== null ? item.TOTALADJUDICADOLICITANTE.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-'}</td>
                                </tr>
                                <tr>
                                    <td><strong>Anexos:</strong></td>
                                    <td>
                                        {item.LinkArquivo && (
                                            <a href={item.LinkArquivo.replace("http://sistemas.tce.pe.gov.br/audinArquivos/licon/processo_licitatorio/edital/778/", "https://www.alepe.pe.gov.br/licitacoes/downloads/")} target="_blank" rel="noopener noreferrer">
                                                Visualizar em PDF
                                            </a>
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                ))}
            </Row>
        </div>
    );
}
